import React, { FC, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { LanguageProvider } from "./common/contexts/LanguageContext";
import { AuthProvider } from "common/contexts/AuthContext";
import theme from "./common/theme/theme";
import { SnackbarProvider } from "notistack";
import AppSpecific from "AppSpecific";
import useSettingsStore from "common/store/SettingsStore";
import LoadingSpinnerBackdrop from "common/components/progress/LoadingSpinner";
/*import { OktaProvider } from "common/contexts/OktaContext";*/
import { Auth0Provider } from '@auth0/auth0-react';
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";




const App: FC = () => {
    const { settings, fetchSettings } = useSettingsStore();
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();


  useEffect(() => {
      fetchSettings();

      const params = new URLSearchParams(location.search);
      const authParam_screen_hint = params.get("screen_hint");
      const authParam_login_hint: string | undefined = params.get("login_hint") || undefined;

      if (!isAuthenticated && authParam_screen_hint === "signup") {
          loginWithRedirect({
              authorizationParams: {
                  screen_hint: "signup",
                  login_hint: authParam_login_hint // optional: pre-fill email
              }
          });
      }

      }, [fetchSettings, isAuthenticated, loginWithRedirect])

  return (
    <>
    { settings.apiBaseUrl === '' ? (<LoadingSpinnerBackdrop /> )
    :(
   /* <OktaProvider>*/
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <LanguageProvider>
          <AuthProvider>
          <Auth0Provider
              domain="auth.emerson.com"
              clientId="a7cBzZyXN0fhNqX8ZB0KA6E3qHG7obHd"
              authorizationParams={{
                  redirect_uri: window.location.origin
              }}>
                                      <AppSpecific />
          </Auth0Provider>
            </AuthProvider>
          </LanguageProvider>
        </SnackbarProvider>
      </ThemeProvider>
  /*  </OktaProvider>*/
  )}
    </>
  );
};

export default App;
